import React from "react";
import { useForm } from "react-hook-form";
import SecondarySkillTopicRequestModel from "../../../../models/admin/skill/request/SecondarySkillTopicRequestModel";
import { GuidEnum } from "../../../../models/enums/GuidEnum";
import { OBJECT_NAME_RULE, OBJECT_DESCRIPTION_RULE } from "../../../../utils/validation-utils";
import toasterUtils from "../../../../utils/toaster-utils";
import { Button, FormControl, TextField } from "@mui/material";

interface SecondarySkillTopicProps {
    secondarySkillId: number;
    onSecondarySkillTopicSave: (objMapping: SecondarySkillTopicRequestModel) => void;
};

const SecondarySkillMappingCreateComponent = (props: SecondarySkillTopicProps) => {
    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<SecondarySkillTopicRequestModel>({
        mode: "onChange"
    });

    const onSubmit = (formData: SecondarySkillTopicRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        formData.topicId = 0;
        formData.secondarySkillId = props.secondarySkillId;
        formData.userId = GuidEnum.Empty;
        formData.description = formData.description === "" ? null : formData.description;
        props.onSecondarySkillTopicSave(formData);
    };

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.topicName}>
                        <TextField label="Topic Name" size="small"
                            {...register("topicName", OBJECT_NAME_RULE)} error={!!errors.topicName} helperText={errors.topicName?.message} placeholder="Enter topic name" autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.description}>
                        <TextField label="Description" size="small" multiline rows={3}
                            {...register("description", OBJECT_DESCRIPTION_RULE)} error={!!errors.description} helperText={errors.description?.message} placeholder="Enter description" autoComplete="off" />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6"></div>
                <div className="col-md-6">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                </div>
            </div>
        </form>
    );
};
export default SecondarySkillMappingCreateComponent;